// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard, Grid } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-controls/swiper-control';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/grid';
import './_collection-driver-pdp.scss';

// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--collection-driver-pdp';
const CAROUSEL_CLASS = 'carousel--collection-driver-pdp';
const CAROUSEL_SECTION_SELECTOR = '.collection-driver-pdp';
const CAROUSEL_SECTION_CLASS = 'collection-driver-pdp';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {

        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        // Generate unique btn classes for slider arrows
        element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
        element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);

        // Generate unique btn classes for swiper pagination
        element.querySelector(CAROUSEL_PAGINATION_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-pagination-${index}`);

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, Grid],
            slidesPerView: 2,
            grid: {
                rows: 2,       // Maximum 2 rows
                fill: 'row',   // Fill the rows first
            },
            spaceBetween: 8,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.

            breakpoints: {
                // when window width is >= 768px
                768: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                    grid: {
                        rows: 1,
                    }
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
            },

            pagination: {
                el: `.${CAROUSEL_SECTION_CLASS}-pagination-${index}`,
                type: 'bullets',
                clickable: true,
            },
        });

        swiper.slides.forEach(function(slide, index) {
            const slideLink = slide.querySelector('a');
            slideLink.addEventListener('focus', function() {
                swiper.slideTo(index);
            });
        });
    });
